export default {
  getFormatedOriginString(state) {
    const country = state.provider
      && state.provider.origin
      && state.provider.origin.country
      && state.provider.origin.country.name;
    const region = state.provider
      && state.provider.origin
      && state.provider.origin.region
      && state.provider.origin.region.name;

    return `${region}, ${country}`;
  },
};
